module.exports = __webpack_public_path__ + "img/home3.9841d444.jpg";